import moment from "moment";
import intl from "react-intl-universal";


const util = {
  requestPath: '/iot/config',
  // requestPath: 'https://mock.ys7.com/mock/152',

  // 当前语言环境"zh-CN" "en-US"
  get currentLang() {
    return intl.options.currentLocale
  },

  /**
   * 获取cookies信息
   *
   * @param name
   * @returns {*}
   */
  getCookie: (name) => {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    }
    return null;
  },
  /**
   * 设置cookie
   *
   * @param {String} name 要设置的cookie名称
   * @param {*} value 设置的cookie值
   * @param {Object} [config] 对应cookie配置的其他属性
   * {
     *   expires {Number} cookie到期时间，天，3天过期 = 3
     *   path {String} cookie生效路径, 设置当前域名下有效 path = '/'
     *   domain {String} 域名设置
     *   secure {Boolean} 安全设置 true http 下不上传到web服务器
     * }
   * @returns {String}
   */
  setCookie: (name, value, config) => {
    const configs = config || {};
    let expires = configs.expires;
    const path = configs.path;
    const domain = configs.domain;
    const secure = configs.secure;

    if (typeof expires === 'number') {
      const days = expires;
      expires = new Date();
      expires.setTime(+expires + (days * 864e+5));
    } else {
      expires = null;
    }
    document.cookie = [
      encodeURIComponent(name), '=', encodeURIComponent(value),
      expires ? `; expires=${expires.toUTCString()}` : '',
      path ? `; path=${path}` : '',
      domain ? `; domain=${domain}` : '',
      secure ? '; secure' : '',
    ].join('');
    return document.cookie;
  },
  /**
   * 生成随机字符串
   * @param l 生成字符串位数
   * @returns {string}
   */
  randomStr: (l) => {
    let index = l || 32;
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    const length = chars.length;
    let result = '';
    while (index) {
      index -= 1;
      result += chars.charAt(Math.floor(Math.random() * length));
    }
    return result;
  },
  /**
   * 数字每个三位加逗号效果
   * @param num
   * @returns {string} 处理后的数据
   */
  formatNum: (num) => {
    if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
      return num;
    }
    const a = RegExp.$1;
    let b = RegExp.$2;
    const c = RegExp.$3;
    const re = /(\d)(\d{3})(,|$)/;
    while (re.test(b)) b = b.replace(re, '$1,$2$3');
    return `${a}${b}${c}`;
  },

  //获取url中的参数
  getQueryString: (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); // 匹配目标参数
    let href = window.location.href.split('?');
    if (href.length > 1) {
      href = href[1];
    } else {
      href = window.location.search.substr(1)
    }
    const result = href.match(reg); // 对querystring匹配目标参数
    if (result != null) {
      return decodeURIComponent(result[2]);
    } else {
      return null;
    }
  },
  /**
   * 获取localStorage的值
   */
  getStorage: (key) => {
    if (!window.localStorage) {
      alert("浏览器不支持localstorage，建议使用chrome浏览器");
    } else {
      const storage = window.localStorage;
      const c = storage.getItem(key);
      return c;
    }
  },
  /**
  * 清除某个localStorage
  */
  removeStorage: (key) => {
    if (!window.localStorage) {
      alert("浏览器不支持localstorage，建议使用chrome浏览器");
    } else {
      const storage = window.localStorage;
      storage.removeItem(key);
    }
  },
  /**
   * 设置localStorage的值
   */
  setStorage: (key, value) => {
    if (!window.localStorage) {
      alert("浏览器不支持localstorage，建议使用chrome浏览器");
    } else {
      var storage = window.localStorage;
      var c = storage.setItem(key, value);
      return c;
    }
  },
  // JSON解析
  parseJSON: (str) => {
    let rst;
    if (str && ({}).toString.call(str) === '[object String]') {
      // 当JSON字符串解析
      try {
        rst = JSON.parse(str);
      } catch (e) {
        // 出错，用eval继续解析JSON字符串
        try {
          // eslint-disable-next-line
          rst = eval(`(${str})`);
        } catch (e2) {
          // 当成普通字符串
          rst = str;
        }
      }
    } else {
      rst = str || {};
    }

    return rst;
  },
  uuid: () => {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
  },

  // 格式化时间
  timeFormat: (time) => moment.utc(time).format("YYYY-MM-DD HH:mm:ss"),

  /**
   * 接入方案
   */
  ACCESSTYPE: {
    1: '免开发 ',
    0: '自定义',
  },

  // 数据格式
  DATATYPE: {
    get noinput() {
      return intl.get('home.product.feature.noinput')
    },
    get boolean() {
      return intl.get('home.product.feature.boolean')
    },
    get string() {
      return intl.get('home.product.feature.string')
    },
    get enum() {
      return intl.get('home.product.feature.enum')
    },
    get integer() {
      return intl.get('home.product.feature.integer')
    },
    get number() {
      return intl.get('home.product.feature.number')
    },
    get object() {
      return intl.get('home.product.feature.json')
    },
    get array() {
      return intl.get('home.product.feature.array')
    },
  },

  // 业务配置
  bizConfig: {
    // 角色权限校验
    supportAccountRole: window.bizConfig && window.bizConfig.supportAccountRole === 1,
    // 接入方案
    supportAccessType: window.bizConfig && window.bizConfig.supportAccessType === 1,
    // 隐藏配网类型中的AP摄像机
    hideAPCamera: window.bizConfig && window.bizConfig.hideAPCamera === 1,
    // 是否支持硬件选型
    supportHardwareSelection: window.bizConfig && window.bizConfig.supportHardwareSelection === 1,
    // logo
    logo: window.bizConfig && window.bizConfig.logo,
    // 登录页背景图
    loginBackground: window.bizConfig && window.bizConfig.loginBackground,
    // 只能使用邮箱登录
    onlyUseEmail: window.bizConfig && window.bizConfig.onlyUseEmail === 1,
    // 隐藏登录底部萤石信息
    hideCopyright: window.bizConfig && window.bizConfig.hideCopyright === 1,
    // 是否有萤石云账号登录
    ezvizAuthEnable: window.bizConfig && window.bizConfig.ezvizAuthEnable === 1,
    // 标准功能点是否可编辑
    standardFeatureEdit: window.bizConfig && window.bizConfig.standardFeatureEdit === 1,
    // 模组管理只支持SDK模式
    onlySupportModuleManageSdk: window.bizConfig && window.bizConfig.onlySupportModuleManageSdk === 1,
    // 隐藏EIB
    hideEIB: window.bizConfig && window.bizConfig.hideEIB === 1,
    // 隐藏OTA升级区域选项
    hideOtaArea: window.bizConfig && window.bizConfig.hideOtaArea === 1,
    //品类管理是否有删除
    categoryManageShowDelete: window.bizConfig && window.bizConfig.categoryManageShowDelete === 1,
    // 产品发布隐藏联系商务
    hideContactBusiness: window.bizConfig && window.bizConfig.hideContactBusiness === 1,
    // 隐藏虚拟设备调试
    hideVirtualDevice: window.bizConfig && window.bizConfig.hideVirtualDevice === 1,
    // 隐藏基线面板描述
    hideBasePannerDes: window.bizConfig && window.bizConfig.hideBasePannerDes === 1,
    // 指定产品ID创建产品
    createProductByProductId: window.bizConfig && window.bizConfig.createProductByProductId === 1,
    // 创建产品支持配网标识
    supportNetworkIdentification: window.bizConfig && window.bizConfig.supportNetworkIdentification === 1,

    // SDK 开发面板上传工具
    cdkCliName: window.bizConfig && window.bizConfig.cdkCliName,
    // cdkCliName:  'PVT-EZM-CLI',
    // SDK 开发面板上传工具使用指南..
    cdkCliHelpLink: window.bizConfig && window.bizConfig.cdkCliHelpLink,
    // cdkCliHelpLink: ''

    //隐藏手机号提示
    hideMobileTip: window.bizConfig && window.bizConfig.hideMobileTip === 1,
    // hideMobileTip:  true,

  },

  /**
   * 通讯协议
   */
  TRANSTYPE: {

    get 1() { return intl.get('home.product.netProtocol.wifi'); },
    get 2() { return intl.get('home.product.netProtocol.bluetooch'); },
    get 3() { return intl.get('home.product.netProtocol.bluetoochAndWifi'); },
    get 4() { return intl.get('home.product.netProtocol.zigbee'); },
    get 5() { return intl.get('home.product.netProtocol.bluetoochMesh'); },
  },

  /**
   * 配网方式key以及对应文案
   */
  NETWORKMODE: {
    get '0'() { return intl.get("home.product.netconfig.0"); },
    get 'noQRcode'() { return intl.get("home.product.netconfig.noQRcode"); },
    get 'bluetooth'() { return intl.get("home.product.netconfig.bluetooth"); },
    get 'blueDetect'() { return intl.get("home.product.netconfig.blueDetect"); },
    get 'zigbee'() { return intl.get("home.product.netconfig.zigbee"); },
    get 'smartconfig'() { return intl.get("home.product.netconfig.smartconfig"); },
    get 'combo'() { return intl.get("home.product.netconfig.combo"); },

  }
};

export default util;
